import {toBoolean} from "./ValueUtils";
import {DEFAULT_LANG, DEFAULT_LOCALE} from "@/localization/Messages";

function asString(el: HTMLElement | null, key: string): string | undefined {
    return el?.dataset && key in el.dataset ? String(el.dataset[key]) : undefined
}

function asBoolean(el: HTMLElement | null, key: string, defaultValue: boolean): boolean {
    return el?.dataset && key in el.dataset ? toBoolean(el.dataset[key], defaultValue) : defaultValue
}

//
// Note that I am trying to avoid jQuery in this module as it could be used by any number of
// bits of code, and as we move towards Vue.js, we will be trying to move away from jQuery.
//
export class PageHelper {
    readonly htmlEl: HTMLElement;
    readonly bodyEl: HTMLElement;
    readonly pageHeaderEl: HTMLElement | null;
    readonly locale: string;
    readonly lang: string;

    constructor() {
        this.htmlEl = globalThis?.document?.documentElement;
        this.bodyEl = globalThis?.document?.body;
        this.pageHeaderEl = globalThis?.document?.getElementById("page-header-container");

        // Ensure we have some fall-backs for these values, even though they should
        // normally come from the HTML element, but it's possible not every page has
        // them set.

        this.locale =
            asString(this.htmlEl, 'locale') ||
            asString(this.pageHeaderEl, 'locale') ||
            asString(this.bodyEl, 'locale') ||
            DEFAULT_LOCALE;

        this.lang =
            this.htmlEl?.getAttribute('lang') ||
            asString(this.pageHeaderEl, 'language') ||
            asString(this.bodyEl, 'language') ||
            DEFAULT_LANG;
    }

    getHeaderString(key: string): string | undefined {
        return asString(this.pageHeaderEl, key);
    }

    getHeaderBoolean(key: string, defaultValue: boolean): boolean {
        return asBoolean(this.pageHeaderEl, key, defaultValue);
    }
}
